import type { AxiosError } from "axios";
import { Service } from "./Service.factory";
import router from "../router";
import { getIsAuthChecking } from "./auth-state";

/**
 * Registra un interceptor que ante respuestas 401 limpia el estado de auth
 * y redirige a /login (salvo durante la verificacion del guard).
 * @param client - instancia del servicio HTTP
 */
export function unauthorizedInterceptor(client: Service) {
  client.interceptors.response.use(
    (res) => res,
    async (err: AxiosError) => {
      if (err.response && err.response.status === 401) {
        if (client.defaults.headers.common) {
          delete client.defaults.headers.common["Authorization"];
          delete client.defaults.headers.common["x-refresh-token"];
        }

        const { useUserStore } = await import("../stores/user.store");
        useUserStore().clearUser();

        if (!getIsAuthChecking() && router.currentRoute.value.path !== "/login") {
          router.push("/login");
        }
      }
      throw err;
    },
  );
}

// Gracias al uso de proxy en vite.config.ts, no es necesario agregar el /api/ al final de la URL
// Ejemplo: /api/auth/login → /auth/login
export const api = new Service(import.meta.env.VITE_API_URL);

unauthorizedInterceptor(api);
